import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { VIEWPORTS } from '../context/DimensionsContext';
export var mobileContent = function mobileContent(props) {
  var breakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : VIEWPORTS.DESKTOP;
  return _defineProperty({}, "@media (max-width: ".concat(breakpoint, "px)"), Object.assign({}, props));
};